<template>
  <div class="rework-success-container">
    <div class="success-card">
      <div class="icon-glow-wrapper">
        <i class="el-icon-s-promotion success-icon"></i>
      </div>
      <h2 class="title">Form Sent to User</h2>
      <p class="subtitle">Successfully returned for rework</p>
      <p class="description">
        The form has been successfully sent back to the user. They’ve been notified and can now
        revise and resubmit it for approval.
      </p>
      <div class="status-pill">
        <i class="el-icon-success icon-pill"></i>
        Rework Initiated Successfully
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GuestFormbuilderReworkSuccess',
  };
</script>

<style scoped>
  .rework-success-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #e0f7fa, #e8f0ff);
    padding: 20px;
    font-family: 'Segoe UI', sans-serif;
  }

  .success-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 32px 24px;
    max-width: 420px;
    width: 100%;
    text-align: center;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
  }

  .icon-glow-wrapper {
    background: linear-gradient(145deg, #d0f0ff, #b4e0ff);
    box-shadow: 0 0 20px rgba(56, 189, 248, 0.4);
    border-radius: 50%;
    width: 72px;
    height: 72px;
    margin: 0 auto 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .success-icon {
    color: #38bdf8;
    font-size: 32px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #0f172a;
    margin-bottom: 6px;
  }

  .subtitle {
    font-size: 16px;
    color: #334155;
    margin-bottom: 14px;
  }

  .description {
    font-size: 15px;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  .status-pill {
    background-color: #ecfdf5;
    color: #10b981;
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
    padding: 6px 16px;
    border-radius: 9999px;
    box-shadow: 0 0 0 1px #d1fae5;
  }
  .icon-pill {
    margin-right: 6px;
    font-size: 16px;
    vertical-align: middle;
    color: #10b981;
  }

  /* Mobile Responsive */
  @media (max-width: 480px) {
    .success-card {
      padding: 24px 16px;
    }

    .title {
      font-size: 22px;
    }

    .subtitle,
    .description {
      font-size: 14px;
    }
  }
</style>
